import { cn } from "../foundations/cn.js";

export interface SkeletonProps {
  /**
   * The surface it sits on: `canvas` (default) for the page or a card's own surface; `raised` for
   * one already lifted (a card on a card, a panel inside a raised frame), where the default fill
   * would barely show.
   */
  tone?: "canvas" | "raised";
  /** Size and radius classes for the shape it stands in for: `h-5 w-32 rounded-sm`. */
  className?: string;
}

/**
 * A placeholder for content still loading, sized like it so nothing shifts when it lands. It
 * pulses by opacity, and holds still under reduced motion.
 */
export function Skeleton({ tone = "canvas", className }: SkeletonProps) {
  return (
    <div
      aria-hidden
      className={cn(
        "rounded-md motion-safe:animate-pulse",
        tone === "raised" ? "bg-bg-hover" : "bg-bg-raised",
        className,
      )}
    />
  );
}
